import React, { Suspense, lazy } from 'react';
import Loading from '../LoadingComponent';

const PipedTextarea = lazy(() =>
  import(/* webpackChunkName: "PipedTextarea" */ '../../components/survey_editor/piped/PipedTextarea')
);

export default function PipedTextareaComponent({...props}) {
  return (
    <Suspense fallback={<Loading />}>
      <PipedTextarea {...props} />
    </Suspense>
  );
}
